import { fromCallback } from 'xstate';

import { usePreventAutoReloadOnNewVersion } from '@eluve/blocks';

const PREVENT_REASON = 'recording';

export const preventBrowserClose = fromCallback(() => {
  usePreventAutoReloadOnNewVersion.getState().addReason(PREVENT_REASON);

  const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = '';
  };

  window.addEventListener('beforeunload', beforeUnloadHandler);
  return () => {
    usePreventAutoReloadOnNewVersion.getState().removeReason(PREVENT_REASON);
    window.removeEventListener('beforeunload', beforeUnloadHandler);
  };
});
